import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SynTacticHub from './SynTacticHub';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <SynTacticHub />
  </React.StrictMode>
);
